export default __webpack_public_path__ + "static/media/infoDark.41eabf55.svg";